"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLifecycle = void 0;
var react_1 = require("react");
var useLifecycle = function (_a) {
    var dispatch = _a.dispatch, value = _a.value, open = _a.open;
    (0, react_1.useEffect)(function () {
        if (!open) {
            dispatch({
                type: 'SET_SELECTED_ITEMS',
                value: value
            });
        }
    }, [open, value, dispatch]);
};
exports.useLifecycle = useLifecycle;
